/**
 * Whiz reçu : la page tremble une demi-seconde et un petit son retentit
 * (comme le « Wizz » de MSN). Le son est synthétisé (Web Audio), aucun
 * fichier à charger. Tremblement coupé avec « Réduire les animations » ou
 * prefers-reduced-motion (ds.css) ; le son reste.
 */
let audio: AudioContext | null = null;

export function playWhiz(reduceMotion: boolean): void {
  if (!reduceMotion) shake();
  try {
    buzz();
  } catch (err) {
    console.warn('[whiz] son indisponible:', err);
  }
}

function shake(): void {
  const el = document.getElementById('root') ?? document.body;
  el.classList.remove('pl-whiz-shake');
  void el.offsetWidth; // relance l'animation si un whiz arrive pendant la précédente
  el.classList.add('pl-whiz-shake');
  el.addEventListener('animationend', () => el.classList.remove('pl-whiz-shake'), { once: true });
}

/** Trois notes courtes et montantes, volume bas. */
function buzz(): void {
  audio ??= new AudioContext();
  const ctx = audio;
  if (ctx.state === 'suspended') void ctx.resume();
  const start = ctx.currentTime + 0.02;
  [660, 880, 1100].forEach((freq, i) => {
    const t = start + i * 0.09;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.12, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.08);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.09);
  });
}

/** Mention « @Prénom » reçue (messagerie) : deux notes douces, plus discrètes que le whiz. */
export function playMentionPing(): void {
  try {
    audio ??= new AudioContext();
    const ctx = audio;
    if (ctx.state === 'suspended') void ctx.resume();
    const start = ctx.currentTime + 0.02;
    [880, 1320].forEach((freq, i) => {
      const t = start + i * 0.12;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.1, t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.2);
    });
  } catch (err) {
    console.warn('[mention] son indisponible:', err);
  }
}
